export default "__VITE_ASSET__BIZX$$RQ__"